export default "/images/discover24x24.svg?b805f08024871ebc484c892a6b4771d0";